var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.personCount===1)?_c('tax-form-control-one',{attrs:{"component-data":_vm.componentProps}}):_vm._e(),_vm._v(" "),(_vm.personCount===2)?_c('tax-form-control-two',{attrs:{"component-data":_vm.componentProps}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }